import { useState, useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';
import './styles/FAQ.css';
import { FaPlus, FaMinus } from 'react-icons/fa';

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);
  const [scrollTracked, setScrollTracked] = useState(false); // para evitar múltiplos disparos

  const faqs = [
    { question: 'O curso é 100% online?', answer: 'Sim! Todo o conteúdo é online e pode ser acessado de qualquer dispositivo com internet.' },
    { question: 'Tenho direito a certificado?', answer: 'Sim, ao concluir o curso você recebe um certificado digital reconhecido em todo o brasil.' },
    { question: 'Como recebo o meu acesso?', answer: 'Após a confirmação do pagamento, você recebe automaticamente um e-mail com as instruções de acesso.' },
    { question: 'Posso renovar o meu acesso?', answer: 'Sim, Após um ano você deverá renovar o acesso para continuar assistindo.' },
    { question: 'Por quanto tempo tenho acesso ao curso?', answer: 'O acesso é válido por 1 ano e você pode assistir quantas vezes quiser, no seu tempo.' },
    { question: 'E se eu não gostar do curso?', answer: 'Você pode solicitar o reembolso dentro do prazo de garantia de 7 dias.' },
    { question: 'E se eu tiver dúvidas durante as aulas?', answer: 'Você terá suporte direto com nossos especialistas para tirar dúvidas.' },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleClickConsultor = () => {
    ReactPixel.track('Contact', {
      action: 'Clique Consultor FAQ',
      origem: 'Seção FAQ',
    });
    ReactPixel.trackCustom('Lead', {
      action: 'Clique Consultor FAQ',
      origem: 'Seção FAQ',
    });
    ReactPixel.trackCustom('ClickWhatsAppCTA', {
      action: 'Clique Consultor FAQ',
      origem: 'Seção FAQ',
    });
    window.open('https://w.app/pjvwxy', '_blank');
  };

  const handleClickFaqCard = () => {
    ReactPixel.track('Lead', {
      action: 'Clique Card FAQ',
      origem: 'Seção FAQ',
    });
  };

  // Pixel de scroll 90%
  useEffect(() => {
    const handleScroll = () => {
      if (scrollTracked) return; // já disparou

      const faqElement = document.querySelector('.FAQ-container');
      if (!faqElement) return;

      const rect = faqElement.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // quando o topo da FAQ estiver dentro de 10% do topo da viewport (90% scroll)
      if (rect.top <= windowHeight * 0.1) {
        ReactPixel.trackCustom('Scroll100', { section: 'FAQ', depth: '100%' });
        setScrollTracked(true); // impede múltiplos disparos
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // checa imediatamente caso o usuário já tenha rolado

    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrollTracked]);

  return (
    <div className="FAQ-container">
      <h3>Dúvidas Frequentes (FAQ)</h3>
      {faqs.map((faq, index) => (
        <div key={index} className="FAQ-card" onClick={() => toggleFAQ(index)}>
          <div className="FAQ-header" onClick={handleClickFaqCard}>
            <h4>{faq.question}</h4>
            <span className={`icon ${activeIndex === index ? 'open' : ''}`}>
              {activeIndex === index ? <FaMinus /> : <FaPlus />}
            </span>
          </div>
          <div className={`FAQ-answer ${activeIndex === index ? 'show' : ''}`}>
            <p>{faq.answer}</p>
          </div>
        </div>
      ))}

      <div className="last-cta">
        <h4>Ainda está com dúvidas?</h4>
        <p>Clique no botão abaixo e fale com um membro de nossa equipe. <br/> Estamos aqui para te ajudar!</p>
        <button className='lastcta-btn' onClick={handleClickConsultor} aria-label="Abrir WhatsApp para falar com um consultor">QUERO FALAR COM UM CONSULTOR</button>
      </div>
    </div>
  );
}

export default FAQ;